import { render, staticRenderFns } from "./ui-badge.vue?vue&type=template&id=cdc6b4a0&"
import script from "./ui-badge.vue?vue&type=script&lang=js&"
export * from "./ui-badge.vue?vue&type=script&lang=js&"
import style0 from "./ui-badge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdc6b4a0')) {
      api.createRecord('cdc6b4a0', component.options)
    } else {
      api.reload('cdc6b4a0', component.options)
    }
    module.hot.accept("./ui-badge.vue?vue&type=template&id=cdc6b4a0&", function () {
      api.rerender('cdc6b4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/ui-badge.vue"
export default component.exports